import React, { useContext } from 'react';
import { Dropdown, Menu, Button, PageHeader, Popconfirm, Divider } from 'antd';
import { DownOutlined, LogoutOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { LANGUAGES, APP_LANGUAGE_KEYS } from 'config/languages';
import LanguageContext from 'contexts/LanguageContext';
import { logout } from 'store/actions/auth.actions';
import './index.scss';
import CurrentUserContext from '../../contexts/CurrentUserContext';

const menu = (changeLanguage) => (
  <Menu>
    {APP_LANGUAGE_KEYS.map(lang_key => (
      <Menu.Item key={lang_key} onClick={() => changeLanguage(LANGUAGES[lang_key])}>
        {lang_key}
      </Menu.Item>
    ))}
  </Menu>
);

const Navbar = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const { email } = useContext(CurrentUserContext);
  const dispatch = useDispatch();
  const intl = useIntl();
  const handleLogout = () => {
    dispatch(logout());
  }

  return (
    <PageHeader
      style={{ background: 'white' }}
      extra={(
        <>
          <Dropdown overlay={menu(changeLanguage)} placement="bottomCenter">
            <Button>
              {language} <DownOutlined />
            </Button>
          </Dropdown>
          <Divider type="vertical" />
          {email
            ? (<>
              {email}
              <Divider type="vertical" />
            </>)
            : null
          }
          <Popconfirm
            title={intl.formatMessage({ id: 'common.logout_confirm' })}
            onConfirm={handleLogout}
            placement="bottomRight"
            okText={intl.formatMessage({ id: 'common.logout' })}
            cancelText={intl.formatMessage({ id: 'common.no' })}
          >
            <LogoutOutlined />
          </Popconfirm>
        </>
      )}
    />
  );
};

export default Navbar;
